//文字コードはutf-8

import { updateTabletScale } from './tabletScale.js';

// ヘッダー検索バーのズーム機能
export function initHeaderSearch() {
  const searchForm = document.querySelector('.jsHeaderSearch');
  const searchInput = document.querySelector('.jsHeaderSearchInput');

  if (!searchForm || !searchInput) return;

  // ズーム状態を管理
  const ZOOM_CLASS = 'is-zoomed';
  let zoomTimeout = null;
  let isZoomed = false;
  let currentZoomLevel = 1; // 現在のズームレベルを保存
  let savedScrollX = 0; // ズーム前のスクロール位置を保存
  let savedScrollY = 0;
  let savedSearchBarX = 0; // ズーム前の検索バーのX座標（ビューポート座標）を保存
  let savedSearchBarY = 0; // ズーム前の検索バーのY座標（ビューポート座標）を保存
  let scrollLockHandler = null; // スクロール位置を固定するハンドラー
  const ZOOM_LEVEL = 1.5; // ズームレベル（1.5倍）
  const ZOOM_LEVEL_SP = 1.2; // スマートフォン用のズームレベル（拡大率を下げる）

  // SPかどうか（768px以下）
  const isSP = () => window.matchMedia('(max-width: 768px)').matches;

  // ズームを適用する関数（SP時のみ実行）
  const applyZoom = () => {
    if (!isSP()) return; // PC・Tabletではズームしない
    if (isZoomed) return;

    isZoomed = true;
    searchForm.classList.add(ZOOM_CLASS);

    // SP時のみここに到達する
    const isTablet = window.matchMedia('(min-width: 769px) and (max-width: 1160px)').matches;
    const zoomLevel = ZOOM_LEVEL_SP;
    currentZoomLevel = zoomLevel;

    // ハンバーガーメニューが開いているかチェック（SP時のみ）
    const header = document.querySelector('.jsHamburgerMenuTarget');
    const isMenuOpen = header && header.classList.contains('is-open');

    // ズーム前のスクロール位置を保存
    savedScrollX = window.scrollX || window.pageXOffset || 0;
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    // PCとタブレットで同じロジックを使用：ヘッダーのposition: fixedを一時的にabsoluteに変更し、位置を調整
    const headerElement = document.querySelector('.header');
    if (headerElement) {
      headerElement.style.position = 'absolute';
      // bodyがtop: -savedScrollYで上に移動するため、ヘッダーをsavedScrollYの位置に配置することで、
      // ビューポートの上部に表示される
      headerElement.style.top = `${savedScrollY}px`;
      headerElement.style.left = '0';
      headerElement.style.right = '0';
      headerElement.style.zIndex = '9999';
    }

    // スクロールを無効化（現在の位置を固定）
    // PCとタブレットで同じロジックを使用：bodyのpositionをfixedに変更
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = `-${savedScrollX}px`;
    document.body.style.touchAction = 'none';

    // スクロールイベントを防止
    scrollLockHandler = (e) => {
      if (e.cancelable) {
        e.preventDefault();
      }
    };
    window.addEventListener('wheel', scrollLockHandler, { passive: false });
    window.addEventListener('touchmove', scrollLockHandler, { passive: false });

    // 検索バーの位置を取得（ビューポート座標）
    // レイアウトが安定するまで少し待つ（特にSPでメニューが開いている場合）
    const getPositionAndApply = () => {
      const rect = searchInput.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      // ズーム前の検索バーの位置を保存（ズーム解除時に使用）
      savedSearchBarX = centerX;
      savedSearchBarY = centerY;

      // デバッグ用ログ
      console.log('[検索バーズーム適用] ====================');
      console.log('検索バーの位置 (getBoundingClientRect):', {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height
      });
      console.log('検索バーの中心座標 (ビューポート):', {
        centerX: centerX,
        centerY: centerY
      });
      console.log('ズーム前の位置を保存:', {
        savedSearchBarX: savedSearchBarX,
        savedSearchBarY: savedSearchBarY
      });

      // body要素にtransformを適用することで、ページ全体（余白を含む）が統一してズームされる
      // bodyがposition: fixedでtop: -savedScrollYになっているため、transform-originの座標系を調整する必要がある
      // ビューポート座標(centerX, centerY)をbodyの座標系に変換: (centerX, centerY + savedScrollY)
      const bodyOriginX = centerX;
      const bodyOriginY = centerY + savedScrollY;

      // PCとタブレットで同じロジックを使用：bodyにtransformを適用
      // タブレット表示時も、.pageWrapper/.headerのスケールは維持しつつ、
      // bodyに追加でズームを適用することで、PCと同じ動作にする
      document.body.style.transform = `scale(${zoomLevel})`;
      document.body.style.transformOrigin = `${bodyOriginX}px ${bodyOriginY}px`;

      // デバッグ用ログ
      console.log('body.transform設定:', {
        transform: `scale(${zoomLevel})`,
        transformOrigin: `${bodyOriginX}px ${bodyOriginY}px`,
        isTablet: isTablet
      });
      console.log('=====================================');
    };

    // SPでメニューが開いている場合は、少し長めに待つ
    if (isMenuOpen) {
      setTimeout(getPositionAndApply, 100);
    } else {
      setTimeout(getPositionAndApply, 50);
    }
  };

  // ズームを解除する関数
  const removeZoom = () => {
    if (!isZoomed) return;

    const isTablet = window.matchMedia('(min-width: 769px) and (max-width: 1160px)').matches;

    // デバッグ用ログ
    console.log('[検索バーズーム解除] ====================');

    // ズームアウト時も、現在の検索バーの位置を基準にtransform-originを設定
    const rect = searchInput.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // デバッグ用ログ
    console.log('検索バーの位置 (getBoundingClientRect):', {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height
    });
    console.log('検索バーの中心座標 (ビューポート):', {
      centerX: centerX,
      centerY: centerY
    });

    // ビューポート座標をbodyの座標系に変換
    const bodyOriginX = centerX;
    const bodyOriginY = centerY + savedScrollY;

    // PCとタブレットで同じロジックを使用：bodyのtransformをリセット
    // ズーム前の検索バーの位置を使用してtransform-originを設定
    const savedBodyOriginX = savedSearchBarX;
    const savedBodyOriginY = savedSearchBarY + savedScrollY;

    document.body.style.transformOrigin = `${savedBodyOriginX}px ${savedBodyOriginY}px`;
    document.body.style.transform = 'scale(1)';

    // デバッグ用ログ
    const isTabletForLog = window.matchMedia('(min-width: 769px) and (max-width: 1160px)').matches;
    console.log('body.transform解除:', {
      transformOrigin: `${savedBodyOriginX}px ${savedBodyOriginY}px`,
      transform: 'scale(1)',
      isTablet: isTabletForLog
    });
    console.log('=====================================');

    // スクロール位置の監視を解除
    if (scrollLockHandler) {
      window.removeEventListener('wheel', scrollLockHandler);
      window.removeEventListener('touchmove', scrollLockHandler);
      scrollLockHandler = null;
    }

    // アニメーション完了後に一気にスタイルをリセット（transitionなしで瞬時に）
    setTimeout(() => {
      const isTabletInTimeout = window.matchMedia('(min-width: 769px) and (max-width: 1160px)').matches;
      isZoomed = false;
      isProcessing = false;
      searchForm.classList.remove(ZOOM_CLASS);

      const headerElement = document.querySelector('.header');

      // スクロール位置をローカル変数に保存
      const targetScrollX = savedScrollX;
      const targetScrollY = savedScrollY;

      // 【ステップ1】全てのtransitionを無効化（瞬時に切り替えるため）
      document.body.style.transition = 'none';
      if (headerElement) {
        headerElement.style.transition = 'none';
      }

      // 【ステップ2】全てのスタイルを一気にリセット
      // body要素のスタイルをリセット
      document.body.style.transform = '';
      document.body.style.transformOrigin = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.touchAction = '';

      // タブレット時は、updateTabletScale()を呼び出す
      if (isTabletInTimeout) {
        // updateTabletScale()を呼び出して--scale-ratioを元の値に戻す（念のため）
        updateTabletScale();
      }

      // ヘッダーのスタイルをリセット
      if (headerElement) {
        headerElement.style.position = '';
        headerElement.style.top = '';
        headerElement.style.left = '';
        headerElement.style.right = '';
        headerElement.style.zIndex = '';
      }

      // 【ステップ3】スクロール位置を復元
      window.scrollTo(targetScrollX, targetScrollY);

      // 【ステップ4】次のフレームでtransitionを復元
      requestAnimationFrame(() => {
        document.body.style.transition = '';
        if (headerElement) {
          headerElement.style.transition = '';
        }

        // 念のため、スクロール位置を再度確認
        window.scrollTo(targetScrollX, targetScrollY);
      });

      currentZoomLevel = 1;
      savedScrollX = 0;
      savedScrollY = 0;
    }, 400); // transition時間に合わせる

    if (zoomTimeout) {
      clearTimeout(zoomTimeout);
      zoomTimeout = null;
    }
  };

  // 処理中フラグ（重複実行を防ぐ）
  let isProcessing = false;

  // 検索フォームまたは入力欄がクリック・タップされたときにズーム（SP時のみ）
  const handleSearchFocus = (e) => {
    // 送信ボタンがクリックされた場合は処理をスキップ
    if (e.target.tagName === 'BUTTON' && e.target.type === 'submit') {
      return;
    }

    // フォーカスを当てる
    searchInput.focus();

    // PC・Tabletではズームせず終了
    if (!isSP()) {
      return;
    }

    // 既に処理中の場合はスキップ
    if (isProcessing) {
      return;
    }

    // 既にズームされている場合は処理をスキップ
    if (isZoomed && document.activeElement === searchInput) {
      return;
    }

    // 処理中フラグを立てる
    isProcessing = true;

    // 既存のタイマーをクリア
    if (zoomTimeout) {
      clearTimeout(zoomTimeout);
      zoomTimeout = null;
    }

    // Android
    const isAndroid = /Android/i.test(navigator.userAgent);
    let rawTime = performance.now();
    let zoomDelay = 0;

    if (isAndroid) {
      zoomDelay = Math.min(rawTime * 0.07, 350);
    } else {
      zoomDelay = 0;
    }

    setTimeout(() => {
      // ズームを適用（SP時のみ）
      applyZoom();

      // 処理完了フラグを少し遅延してリセット（元コード通り）
      setTimeout(() => {
        isProcessing = false;
      }, 200);
    }, zoomDelay);
  };

  // フォーカスが外れたときにズームを解除
  const handleSearchBlur = () => {
    // 処理中（ズーム適用中）の場合は解除しない
    if (isProcessing) {
      return;
    }

    // 少し遅延を入れて、他の要素へのフォーカス移動を待つ
    zoomTimeout = setTimeout(() => {
      // まだ検索入力欄にフォーカスがある場合は解除しない
      if (document.activeElement !== searchInput && !isProcessing) {
        removeZoom();
      }
    }, 100);
  };

  // フォーム全体のクリックイベント（キャプチャフェーズで処理）
  searchForm.addEventListener('click', (e) => {
    // inputがクリックされた場合は、フォーカスイベントに任せる
    if (e.target === searchInput || e.target.closest('input')) {
      return;
    }
    handleSearchFocus(e);
  }, { passive: true, capture: true });

  // 入力欄のフォーカスイベント（直接フォーカスされた場合も対応）
  searchInput.addEventListener('focus', handleSearchFocus, { passive: true });

  // 入力欄のフォーカス解除イベント
  searchInput.addEventListener('blur', handleSearchBlur, { passive: true });

  // ページの他の場所をクリックしたときにズームを解除
  document.addEventListener('click', (e) => {
    // 処理中（ズーム適用中）の場合は解除しない
    if (isProcessing) {
      return;
    }
    // フォーム内のクリックは無視
    if (searchForm.contains(e.target)) {
      return;
    }
    removeZoom();
  }, { passive: true });

  // ESCキーでズームを解除
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isZoomed) {
      removeZoom();
      searchInput.blur();
    }
  }, { passive: true });

  // ウィンドウリサイズ時にズームを解除（レイアウトの崩れを防ぐ）
  let resizeTimeout = null;
  window.addEventListener('resize', () => {
    if (isZoomed) {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(() => {
        removeZoom();
      }, 150);
    }
  }, { passive: true });
}
